﻿import { Configurator } from "@models/configurators/configurator";
import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { Field } from "@models/configurators/field";
import { Group } from "@models/configurators/group";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPage } from "@models/entity-models";
import { icons } from "@tools";
import { NestedSet } from "./nested-set";

@Kbo(CToken.Page)
export class Page extends UiObject implements IPage {

    constructor(kom: KbObjectManager) {
        super(kom);

        this.icon = "";
        if (icons) {
            this.icon = icons.page;
        }
    }
    public icon: string;
    public iconStyle: string;
    public mediaPath: string;
    public mediaPathWhenSelected: string;
    // public visible: boolean = true;

    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }

    /**
     * Groups array has been deprecated.  This readonly property is here for
     * backwards compatibility
     */
    public get groups(): Group[]{
        return this.getChildrenOfType<Group>(CToken.Group);
    }

        
    private _pages: Page[];
    @Enumerable()
    public get pages(): Page[] {
        if (!this._pages) this._pages = [];
        return this._pages;
    }
    public set pages(val) {
        this._pages = val;
    }

    private _configurators: Configurator[];
    @Enumerable()
    public get configurators(): Configurator[] {
        if (!this._configurators) this._configurators = [];
        return this._configurators;
    }
    public set configurators(val) {
        this._configurators = val;
    }

    public addGroup(): Group {
        let group = new Group(this.$manager);
        this.$manager.addKbObject(group, this);
        this.children.push(group);
        return group;
    }

    public removeGroup(group: Group) {
        this.$manager.removeKbObject(group);
        this.children.remove(group);
    }

    public addPage(): Page {
        let page = new Page(this.$manager);
        this.$manager.addKbObject(page, this);
        this.pages.push(page);
        return page;
    }

    public removePage(page: Page) {
        this.$manager.removeKbObject(page);
        this.pages.remove(page);
    }

    public allPages(): Page[] {
        return this.getChildrenOfType<Page>(CToken.Page);
    }

    public getFields(predicate?: (field: Field) => boolean): Field[] {
        let fields = this.getChildrenOfType<Field>(CToken.Field);
        return predicate ? fields.filter(f => predicate(f)) : fields;
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children.concat(this.pages)
        );
    }

    public isValid(): boolean {
        let fields = this.getFields();
        let valid = !fields.some(f => !f.isValid());
        if (!valid) {
            this.$valid = false;
            return this.$valid;
        }

        for (let config of this.configurators) {
            if (!config.isValid()) {
                this.$valid = false;
                return this.$valid;
            }
        }
        let nestedSets = this.getChildrenOfType<NestedSet>(CToken.NestedSet);
        for (let ns of nestedSets) {
            for (let nested of ns.configurators) {
                if (!nested.isValid()) {
                    this.$valid = false;
                    return this.$valid;
                }
            }
        }
        this.$valid = true;
        return this.$valid;
    }
    

    public allowedChildren(rootType: CToken): CToken[] {
        let allowed = this.containerChildren(rootType);
        if (rootType == CToken.Configurator) {
            allowed.splice(0, 0, CToken.Page); //pages can have nested pages
        }
        return allowed;
    }


    public ignoredProperties(): string[]{
        return ["groups"];
    }
}
